$.fn.iconsPicker = function() {
    return this.each((index, el) => {
        let node = $(el);
        let current = node.val();

        $.ajax({
            method: 'GET',
            url: '/bootstrap5.json',
            dataType: 'JSON',
            success: (icons) => {
                let table = '<table><tr>';

                icons.forEach((icon, index) => {
                    if (index != 0 && index % 50 == 0) {
                        table += '</tr><tr>';
                    }

                    if (current == icon) {
                        table += '<td class="p-1 bg-success"><i class="bi bi-' + icon + '"></i></td>';
                    }
                    else {
                        table += '<td class="p-1"><i class="bi bi-' + icon + '"></i></td>';
                    }
                });

                table += '</tr>';

                table = $(table);
                table.find('i').click((e) => {
                    let ico = $(e.currentTarget);
                    let selected = ico.attr('class').split(' ')[1];
                    node.attr('value', selected);
                    ico.closest('table').find('td').removeClass('bg-success');
                    ico.closest('td').addClass('bg-success');
                });

                new bootstrap.Popover('#' + node.attr('id'), {
                    trigger: 'focus',
                    html: true,
                    sanitize: false,
                    content: table,
                    placement: 'bottom',
                    customClass: 'icons-popover large-popover',
                });
            }
        });
    });
}
